
/**
 * 神策数据上报
 * @see https://shimo.im/docs/KlkKVeVGYNszvEqd
 * @see https://manual.sensorsdata.cn/sa/latest/tech_sdk_client_web_use-7545346.html
 */

/**
 * 火山引擎数据上报
 * @see https://www.tapd.cn/41320242/prong/stories/view/1141320242001006364
 * @see https://www.volcengine.com/docs/6285/93209
 */

import * as utils from './index'

const paramCode = Symbol('code')
const paramUID = Symbol('uid')

class SensorsReport {
  constructor (options = {}) {
    this.timer = null
    this.finderTimer = null

    this[paramCode] = ''
    this[paramUID] = ''

    this.token = undefined
    this.dataFinderID = undefined
  }

  /**
   * 神策的公共方法
   */
  // get sensors () {
  //   return window.sensors
  // }

  /**
   * 火车引擎的公共方法
   */
  get dataFinder () {
    return window.collectEvent
  }

  get code () {
    return this[paramCode]
  }

  get uid () {
    return this[paramUID]
  }

  // get anonymousID () {
  //   return this.sensors && this.sensors.quick('getAnonymousID')
  // }

  get platform () {
    const ua = navigator.userAgent.toLowerCase()

    return (!/iphone|android|ucweb|ucbrowser|nokia|sony|ericsson|mot|samsung|sgh|lg|philips|panasonic|alcatel|lenovo|cldc|midp|wap|mobile/i.test(ua) && !/ipad/i.test(ua)) ? 'Web' : 'H5'
  }

  /**
   * 获取公共属性
   */
  get common () {
    const data = {}

    if (this.uid) data.uid = this.uid
    if (this.platform) data.report_source = this.platform

    const utmKeys = [
      ['utm_source', 'custom_utm_source'],
      ['utm_medium', 'custom_utm_medium'],
      ['utm_campaign', 'custom_utm_campaign'],
      ['utm_content', 'custom_utm_content'],
      ['utm_term', 'custom_utm_term']
    ]

    utmKeys.forEach(([orginalK, k]) => {
      const val = utils.getQueryString(window.location.href, orginalK)
      if (val) data[k] = val
    })

    return data
  }

  getLogger (callback, reportTools = this.dataFinder) {
    if (reportTools) {
      callback(reportTools)

      return
    }

    let count = 0

    let timer = reportTools === this.dataFinder ? this.finderTimer : this.timer

    timer = setInterval(() => {
      if (count >= 5) {
        clearInterval(timer)
      }

      if (reportTools) {
        clearInterval(timer)
        callback(reportTools)
      }

      count++
    }, 500)
  }

  /**
   * 设置公共属性
   * @param {Object} logined 登录用户信息
   */
  init (logined) {
    this[paramUID] = logined ? logined.uid : ''

    const commonParams = Object.assign({}, this.common, {
      is_login: !!logined
    })

    // this.getLogger(looger => {
    //   looger.registerPage(commonParams)
    //   // looger.quick('autoTrack')
    // })

    this.getLogger(looger => {
      looger('init', {
        autotrack: false, // 是否开启全埋点
        log: false,
        app_id: '',
        channel_domain: 'https://gator.volces.com', // 设置数据上送地址
        cross_subdomain: true, // 是否自动跨子域名识别用户
        spa: true, // 是否开启路由变化的监控
        enable_native: true // 是否走原生 native sdk 上报
      })
      // 必须在初始化配置完成后，加入这行代码，否则SDK不会发送数据
      looger('start')
      looger('config', commonParams)
    })
  }

  /**
   * 数据上报
   * @param {String}  key      事件名称
   * @param {Object} [params]  事件数据
   * @param {Function} func    回调事件，仅神策可用
   */
  pushEvent (key, params = {}, func = function () {}) {
    this.getLogger(looger => {
      // 使用 Navigator.sendBeacon() 发送事件，防止因为页面跳转而丢失上报数据
      looger('beconEvent', key, params)
      // looger(key, params)
    })
  }
}

const sensorsReport = new SensorsReport()

export default sensorsReport
